import React from 'react';
import styled from 'styled-components';
import { CookieOutlined, HelpOutlineOutlined, CheckCircleOutline, SettingsOutlined } from '@mui/icons-material';

const PageContainer = styled.div`
  padding: 40px;
  max-width: 900px;
  margin: 0 auto;
  font-family: '"Proxima Nova"', sans-serif;
  line-height: 1.6;
`;

const Heading = styled.h1`
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 20px;
`;

const Section = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 40px;
`;

const IconWrapper = styled.div`
  margin-right: 25px;
  color: #007bff;
  margin-top: -5px; /* Align icon better with text */
`;

const SectionContent = styled.div`
  flex: 1;
`;

const SectionTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 10px;
`;

const ManageCookies = () => {
  return (
    <PageContainer>
      <Heading>Cookie Policy</Heading>
      <p>
        This policy explains how DevOps Buddy, a service by Vaidhyamegha Pvt. Ltd., uses cookies and similar technologies to recognize you when you visit our website.
      </p>

      <Section>
        <IconWrapper><HelpOutlineOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>What are cookies?</SectionTitle>
          <p>Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners in order to make their websites work, or to work more efficiently, as well as to provide reporting information.</p>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><CookieOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>How we use cookies</SectionTitle>
          <p>We use cookies for several reasons:</p>
          <ul>
            <li><strong>Essential Cookies:</strong> These are strictly necessary to provide you with services available through our website, such as authenticating you and keeping you logged in.</li>
            <li><strong>Performance and Analytics Cookies:</strong> These cookies collect information that is used in aggregate form to help us understand how our website is being used or how effective our marketing campaigns are.</li>
            <li><strong>Functionality Cookies:</strong> These are used to recognize you when you return to our website and enable us to remember choices you make (such as your user name or region).</li>
          </ul>
        </SectionContent>
      </Section>

      <Section>
        <IconWrapper><SettingsOutlined fontSize="large" /></IconWrapper>
        <SectionContent>
          <SectionTitle>How can I control cookies?</SectionTitle>
          <p>You have the right to decide whether to accept or reject cookies. You can exercise your cookie preferences by setting or amending your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our website though your access to some functionality and areas of our website may be restricted.</p>
          <p>As the means by which you can refuse cookies through your web browser controls vary from browser-to-browser, you should visit your browser's help menu for more information.</p>
        </SectionContent>
      </Section>
    </PageContainer>
  );
};

export default ManageCookies;
